/* frenchmac-product-pin.js — Page produit : la scène (fil d'Ariane + galerie +
 * colonne d'infos) reste ancrée à sa place DÈS le premier pixel de défilement.
 * Seule la colonne d'infos de droite glisse. Quand elle est épuisée, la scène
 * se décroche et la page reprend son défilement normal.
 *
 * Aucun détournement du scroll : la molette garde sa course naturelle, on ne
 * fait que coller la scène (position: sticky) et translater la colonne droite.
 *
 * Ce qui suit la scène dans la fiche (cross-sell moniteur, barre d'achat…)
 * reste HORS de l'épinglage et défile normalement.
 *
 * Désactivé sous 991 px (mise en page à une colonne), si l'utilisateur demande
 * moins d'animations, ou si la scène est trop courte pour la galerie.
 */
(function () {
  'use strict';

  var MIN_WIDTH = 991;
  var MIN_COURSE = 120;   /* en dessous, le pin n'apporte rien */
  var MARGIN = 24;        /* respiration sous la galerie */

  var section = document.querySelector('.fm-product');
  if (!section) return;

  var breadcrumb = section.querySelector('.fm-product__breadcrumb');
  var inner = section.querySelector('.fm-product__inner');
  var media = section.querySelector('.fm-product__media');
  var info  = section.querySelector('.fm-product__info');
  if (!inner || !media || !info) return;

  /* Scène = fil d'Ariane + grille produit, et RIEN d'autre : les blocs qui
   * suivent dans la fiche doivent continuer à défiler. */
  var pin = document.createElement('div');
  pin.className = 'fm-product__pin';
  var stage = document.createElement('div');
  stage.className = 'fm-product__stage';
  pin.appendChild(stage);
  section.insertBefore(pin, breadcrumb || inner);
  if (breadcrumb) stage.appendChild(breadcrumb);
  stage.appendChild(inner);

  /* La colonne d'infos glisse à l'intérieur d'une fenêtre qui la rogne. */
  var scroller = document.createElement('div');
  scroller.className = 'fm-product__info-scroller';
  info.parentNode.insertBefore(scroller, info);
  scroller.appendChild(info);

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var on = false, course = 0, ticking = false;

  function off() {
    on = false;
    pin.classList.remove('is-on');
    pin.style.removeProperty('height');
    stage.style.removeProperty('--fm-pin-top');
    stage.style.removeProperty('--fm-pin-stage');
    info.style.transform = '';
  }

  function measure() {
    off();
    if (window.innerWidth < MIN_WIDTH || reduce.matches) return;

    var y = window.scrollY || window.pageYOffset || 0;
    var top = Math.round(stage.getBoundingClientRect().top + y); /* place d'origine */
    var height = Math.round(window.innerHeight - top);
    if (top < 0 || height < 320) return;

    stage.style.setProperty('--fm-pin-top', top + 'px');
    stage.style.setProperty('--fm-pin-stage', height + 'px');
    pin.classList.add('is-on');

    /* Mesures prises APRÈS application de la mise en page épinglée. */
    var visible = scroller.clientHeight;
    var needed  = info.scrollHeight;
    course = Math.round(needed - visible);

    /* La galerie doit tenir dans la scène, sinon on revient au comportement
     * d'origine (galerie collante classique). */
    if (media.getBoundingClientRect().height + MARGIN > height || course < MIN_COURSE) {
      off();
      return;
    }

    /* La scène colle dès le premier pixel de défilement : la course part de 0. */
    on = true;
    pin.style.height = (height + course) + 'px';
    update();
  }

  function update() {
    if (!on) return;
    var y = window.scrollY || window.pageYOffset || 0;
    var p = y < 0 ? 0 : (y > course ? course : y);
    info.style.transform = 'translate3d(0,' + (-p) + 'px,0)';
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }

  var timer = null;
  function onResize() {
    clearTimeout(timer);
    timer = setTimeout(measure, 150);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  if (reduce.addEventListener) reduce.addEventListener('change', measure);

  /* La colonne d'infos change de hauteur quand on ouvre un accordéon ou qu'on
   * change de variante : on re-mesure au lieu de garder une course périmée. */
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(onResize);
    ro.observe(info);
    ro.observe(media);
  }

  /* Une passe tout de suite, une autre quand images et polices ont fini de
   * charger : la hauteur de la colonne droite bouge encore d'ici là. */
  window.addEventListener('load', measure);
  measure();
})();
